import { formatCPF } from "@brazilian-utils/brazilian-utils";
import { Flex, Text } from "@chakra-ui/layout";
import { Skeleton, SkeletonCircle } from "@chakra-ui/react";
import { UnidadePaginateResponse } from "core/features/unidades/typings/unidade";
import PrimaryButton from "ui/components/Button/PrimaryButton";

interface UnidadeDetailsProps {
  unidade?: UnidadePaginateResponse;
  onEdit: () => void;
  loading?: boolean;
}

function UnidadeDetails({ unidade, onEdit, loading }: UnidadeDetailsProps) {
  return (
    <>
      {loading ? (
        <Flex h="320px" w="100%" flexDir="column">
          <SkeletonCircle h="40px" w="40px" alignSelf="center" mb={4} />
          <Skeleton h="40px" w="100%" flex={1} mb={4} />
          <Skeleton h="40px" w="100%" flex={1} mb={4} />
          <Skeleton h="40px" w="100%" flex={1} mb={4} />
          <Skeleton h="40px" w="100%" flex={1} mb={4} />
          <Skeleton h="40px" w="100%" flex={1} mb={4} />
        </Flex>
      ) : (
        <Flex flexDir="column" flex="1">
          <Flex
            flexDir="column"
            alignItems="center"
            flex="1"
            justifyContent="center"
            my="16px"
          >
            {unidade?.numero.match(/\D/g) ? (
              <Flex
                justifyContent="center"
                alignItems="center"
                color="white"
                bg="purple"
                rounded="4px"
                px="10px"
                h="50px"
                fontSize="18px"
              >
                {unidade?.numero}
              </Flex>
            ) : (
              <Flex
                justifyContent="center"
                alignItems="center"
                rounded="full"
                color="white"
                bg="purple"
                w="50px"
                h="50px"
                fontSize="18px"
              >
                {unidade?.numero}
              </Flex>
            )}
          </Flex>

          <Flex flexDir="column">
            {unidade?.blocoQuadra ? (
              <Flex flexDir="column">
                <Text fontWeight="bold" fontSize="12px">
                  Bloco/Quadra
                </Text>
                <Text mt="-2px">{unidade.blocoQuadra.nome}</Text>
              </Flex>
            ) : null}

            <Flex mt="16px" flexDir="column">
              <Text fontWeight="bold" fontSize="12px">
                Área total
              </Text>
              <Text mt="-2px">{unidade?.area ?? "---"}m2</Text>
            </Flex>

            <Flex mt="16px" flexDir="column">
              <Text fontWeight="bold" fontSize="12px">
                Morador
              </Text>
              <Text mt="-2px">{unidade?.pessoa?.nome}</Text>
            </Flex>

            <Flex mt="16px" flexDir="column">
              <Text fontWeight="bold" fontSize="12px">
                Documento
              </Text>
              <Text mt="-2px">
                {unidade?.pessoa?.documento
                  ? formatCPF(unidade.pessoa.documento)
                  : "---"}
              </Text>
            </Flex>

            <Flex mt="32px" flexDir="column">
              <PrimaryButton onClick={() => onEdit()}>Editar</PrimaryButton>
            </Flex>
          </Flex>
        </Flex>
      )}
    </>
  );
}

export default UnidadeDetails;
